<template>
  <div class="personalCenter">

    <el-menu
      ref="menu"
      @select="tabSelect"
      :default-active="activeIndex"
      class="el-menu-vertical"
      active-text-color="#FFFFFFFF">
      <el-menu-item index="1">
        <img v-if="activeIndex == 1" class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_ziliao_selected.png">
        <img v-else class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_ziliao_default.png">
        <span slot="title">我的资料</span>
      </el-menu-item>
      <el-menu-item index="2">
        <img v-if="activeIndex == 2" class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_fabuzhaogong_selected.png">
        <img v-else class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_fabuzhaogong_default.png">
        <span slot="title">发布招工信息</span>
      </el-menu-item>
      <el-menu-item index="3">
        <img v-if="activeIndex == 3" class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_zhaohuoguanggao_selected.png">
        <img v-else class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_zhaohuoguanggao_default.png">
        <span slot="title">我的找活名片</span>
      </el-menu-item>
      <el-menu-item index="4">
        <img v-if="activeIndex == 4" class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_wodexiangmu_selected.png">
        <img v-else class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_wodexiangmu_default.png">
        <span slot="title">我的招工</span>
      </el-menu-item>
      <el-menu-item index="5">
        <img v-if="activeIndex == 5" class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_zuzhi_selected.png">
        <img v-else class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_zuzhi_default.png">
        <span slot="title">我的组织</span>
      </el-menu-item>
      <el-menu-item index="6">
        <img v-if="activeIndex == 6" class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_xinyong_selected.png">
        <img v-else class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_xinyong_default.png">
        <span slot="title">信用评价</span>
      </el-menu-item>
      <el-menu-item index="7">
        <img v-if="activeIndex == 7" class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_yaogongbi_selected.png">
        <img v-else class="menu-icon"
             src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/public/profile_icon_yaogongbi_default.png">
        <span slot="title">我的邀工币</span>
      </el-menu-item>
      <!--      <el-menu-item index="8">-->
      <!--        <i class="el-icon-setting"></i>-->
      <!--        <span slot="title">我的积分</span>-->
      <!--      </el-menu-item>-->
      <!--      <el-menu-item index="9">-->
      <!--        <i class="el-icon-setting"></i>-->
      <!--        <span slot="title">积分商城</span>-->
      <!--      </el-menu-item>-->
    </el-menu>

    <download v-if="downloadShow" @close="closeDownload"></download>

  </div>
</template>

<script>

import {coinRecord} from "@api/coins";
import {loginIsAuth} from "@api/public";
import download from "@views/components/download";

export default {
  name: 'personalCenter',
  components: {
    download
  },
  props: ['activeIndex'],
  data() {
    return {
      // activeIndex: '1',
      tabActive: '1',
      downloadShow: false,
    }
  },
  created() {
    this.tabActive = this.activeIndex
  },
  mounted() {
  },
  methods: {
    // 弹出登录
    showDownload() {
      this.downloadShow = true
    },

    closeDownload() {
      this.downloadShow = false
    },

    // 验证是否需要认证
    loginIsAuth(e, url) {
      loginIsAuth().then(res => {
        if (res.data.code === 200) {
          if (res.data.data.isAuth === 1) {
            this.tabActive = e
            this.$router.push(url)
          } else {
            this.$refs.menu.activeIndex = this.tabActive
            this.showDownload()
            this.$forceUpdate()
          }
        }
      });
    },

    tabSelect(e) {

      if (e === '1') {
        this.tabActive = e
        this.$router.push('/userInfo')
      } else if (e === '2') {
        this.loginIsAuth(e, '/personalCenter/pubJob/index')
      } else if (e === '3') {
        this.loginIsAuth(e, '/personalCenter/getWorkAdvertising/index')
      } else if (e === '4') {
        this.tabActive = e
        this.$router.push('/project')
      } else if (e === '5') {
        this.tabActive = e
        // 登录身份 0 个人， 1 班组， 2企业
        let currentRole = localStorage.getItem('currentRole')
        if (currentRole == -1) {
          this.$router.push('/personalCenter/org/index')
        } else if (currentRole == 0) {
          this.$router.push('/personalCenter/org/index')
        } else {
          this.$router.push('/personalCenter/org/info')
        }
      } else if (e === '6') {
        this.tabActive = e
        this.$router.push('/personalCenter/creditRating/index')
      } else if (e === '7') {
        this.tabActive = e
        this.$router.push('/personalCenter/coins/index')
      } else if (e === '8') {
        this.tabActive = e
      } else if (e === '9') {
        this.tabActive = e
      }
    }

  }
}
</script>

<style lang="scss">
.personalCenter {
  width: 200px;
  margin-top: 20px;

  .el-menu {
    box-shadow: 0px 0px 20px #e6e6e6;
    //border-radius: 5px;
    border: solid 0px #e6e6e6;

    .menu-icon {
      margin-right: 10px;
    }
  }

  .el-menu-item.is-active {
    background-color: #37A1FFFF;
  }

}
</style>
